import { TinyColor } from '@ctrl/tinycolor';
import type { BdColorFactoryType } from './color-factory';
import { BdColorFactory } from './color-factory';

export class BdColorJudgementFactory extends BdColorFactory {
  type: BdColorFactoryType = 'judgement';

  public static fromObject(obj: any): BdColorJudgementFactory {
    const good =
      !!obj && !!obj.good
        ? new TinyColor(obj.good)
        : new TinyColor('rgb(0, 255, 0)');
    const bad =
      !!obj && !!obj.bad
        ? new TinyColor(obj.bad)
        : new TinyColor('rgb(255, 0, 0)');

    return new BdColorJudgementFactory(good, bad);
  }

  constructor(
    public good: TinyColor = new TinyColor('rgb(0, 255, 0)'),
    public bad: TinyColor = new TinyColor('rgb(255, 0, 0)'),
  ) {
    super();
  }

  clone(): BdColorFactory {
    return new BdColorJudgementFactory(this.good.clone(), this.bad.clone());
  }

  toJSON(): unknown {
    return {
      type: this.type,
      good: this.good.toHexString(),
      bad: this.bad.toHexString(),
    };
  }

  getColorForValue(
    value: number,
    minValue: number,
    maxValue: number,
  ): TinyColor | null {
    let result: TinyColor;

    if (value === 0) {
      // neutral value returns 'color' but fully transparent
      result = new TinyColor('rgba(255, 255, 255, 1)');
    } else if (value > 0) {
      const hsl = this.good.toHsl();
      const lightenRange = 1 - this.good.toHsl().l;
      const percentage = 1 - value / maxValue;

      hsl.l = hsl.l + lightenRange * percentage;

      result = new TinyColor(hsl);
    } else {
      const hsl = this.bad.toHsl();
      const lightenRange = this.bad.toHsl().l;
      const percentage = 1 - value / minValue;

      hsl.l = hsl.l + lightenRange * percentage;

      result = new TinyColor(hsl);
    }

    return result;
  }

  equals(other: BdColorFactory): boolean {
    switch (other.type) {
      case 'judgement': {
        return (
          this.good.equals((other as BdColorJudgementFactory).good) &&
          this.bad.equals((other as BdColorJudgementFactory).bad)
        );
      }
      default: {
        return false;
      }
    }
  }
}
